import React, { useEffect, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { HeaderScrollEffect } from '../../helpers/HeaderScrollEffect';
import {
  AppBar,
  IconButton,
  makeStyles,
  useScrollTrigger
} from '@material-ui/core';
import { Coin, MoneyBag } from '../../assets/icons/iconComponents2';
import { useDispatch, useSelector } from 'react-redux';
import ExitToAppRoundedIcon from '@material-ui/icons/ExitToAppRounded';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';

import SettingsIcon from '@material-ui/icons/Settings';
import {
  getMyProfileRequest,
  getNotificationsCountRequest,
  getOrganizationFeaturesRequest,
  remove_token
} from '../../helpers/api';
import { routes } from '../../assets/routes';
import Logo from '../../assets/icons/logo.png';
import { toast } from 'react-toastify';
import { setUserInfo } from '../../reactRedux/Actions/userAction';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import styles from './Header.module.scss';
import classNames from 'classnames';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbUp';
import Badge from '@material-ui/core/Badge';
import { NotificationFilled } from '../../assets/icons/iconComponents';
import PollIcon from '@material-ui/icons/Poll';
import { modules } from '../../helpers/modules';
// import ShowChartIcon from '@material-ui/icons/ShowChart';
import PropTypes from 'prop-types';
import { useQuery } from '@tanstack/react-query';
import CakeIcon from '@material-ui/icons/Cake';
// import DashboardIcon from '@material-ui/icons/Dashboard';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import { useTranslation } from '../../i18n/LanguageProvider';
const useStyles = makeStyles((theme) => ({
  container: {
    background: (props) =>
      props.trigger ? theme.palette.common.white : 'transparent',
    transition: 'ease 300ms',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: 60,
    padding: theme.spacing(0, 2),
    color: 'inherit',
    '& span': {
      direction: 'ltr'
    },
    '& > h1': {
      transition: 'ease 300ms'
      // opacity: props => props.trigger ? 0 : 1,
    }
  },
  buttons: {
    color: theme.palette.common.black,
    transition: 'ease .1s'
    // background: props => props.trigger ? theme.palette.common.white : 'initial',
    // boxShadow: props => props.trigger ? '0 0 4px 0 #00000033' : 'none',
  },
  coins: {
    display: 'flex',
    fontSize: 18,
    fontWeight: 'bold',

    '& > div': {
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'center',

      '&  > span': {
        marginInlineStart: 4
      },

      '&:first-child': {
        marginInlineEnd: 8
      }
    }
  },
  exit: {
    color: theme.palette.error.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.spacing(0.5),
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,

    '& > svg': {
      marginInlineStart: 4
    },
    // the icon's arrow points outwards, i.e. towards the inline end
    'html[dir="rtl"] & > svg': {
      transform: 'rotate(180deg)'
    }
  },
  back: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.spacing(0.5),

    '& svg': {
      color: theme.palette.common.black
    },
    // english convention: back sits before the title, at the top left
    'html[dir="ltr"] &': {
      order: -1
    }
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  titleAfterBack: {
    marginInlineEnd: 'auto'
  },
  logo: {
    height: theme.spacing(6),
    marginInlineEnd: theme.spacing(1)
  }
}));

const Header = (props) => {
  const { t, isRtl } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 30,
    target: props.window ? props.window() : undefined
  });
  const classes = useStyles({ ...props, trigger });
  const userInfo = useSelector((state) => state.userReducer);
  const currentPath = props.location.pathname;
  // const env = process.env.REACT_APP_ENV;

  const [info, setInfo] = useState({ score: '-', credit: '-' });
  const [open, setOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const headerStates = useSelector((state) => state.headerReducer);
  const userInfoUpdate = (data) => dispatch(setUserInfo(data));

  const { data, isLoading, refetch } = useQuery(
    ['myProfile'],
    getMyProfileRequest,
    {
      onSuccess(response) {
        userInfoUpdate({
          username: response.username,
          credit: response.credit,
          score: response.score,
          full_name: `${response.first_name} ${response.last_name}`,
          avatar: response.avatar?.thumbnail
        });
        setInfo({
          score: response.score,
          credit: response.credit
        });
      },
      onError(err) {
        toast.error(err.response?.data.detail);
      }
    }
  );

  const { data: orgFeatures } = useQuery(
    ['organizationFeatures'],
    getOrganizationFeaturesRequest
  );

  useQuery(['notificationsCount'], getNotificationsCountRequest, {
    onSuccess({ data: { notif_count, todo_count } }) {
      setNotificationCount(notif_count + todo_count);
    }
  });

  const exitFn = () => {
    remove_token();
    history.push(routes.LOGIN);
  };

  const openDrawer = () => {
    setOpen(true);
  };
  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setOpen(open);
  };

  useEffect(() => refetch(), [headerStates]);

  const handleNavClick = (e) => {
    setOpen(false);
    return currentPath === routes.FEEDBACKS ? e.preventDefault() : null;
  };

  const hasFeedback = orgFeatures?.data?.find(
    (feature) => feature.feature_name === 'feedback'
  )?.active;

  return (
    <HeaderScrollEffect {...props}>
      <AppBar position={'sticky'} className={classes.container}>
        {headerStates.showDrawer && (
          <IconButton edge="end">
            <MenuRoundedIcon onClick={openDrawer} />
          </IconButton>
        )}
        <div
          className={classNames(classes.titleContainer, {
            [classes.titleAfterBack]: headerStates.showBack && !isRtl
          })}
        >
          {!isLoading && headerStates.showLogo && (
            <img
              src={
                data.organization?.logo?.thumbnail
                  ? data.organization?.logo?.thumbnail
                  : Logo
              }
              alt="logo"
              className={classes.logo}
            />
          )}
          <h1>{headerStates.title}</h1>
        </div>
        {headerStates.showNotification && (
          <IconButton
            edge="start"
            onClick={() => history.push(routes.NOTIFICATION_LIST)}
          >
            <Badge
              color="error"
              overlap="circle"
              variant="dot"
              invisible={!notificationCount}
            >
              <NotificationFilled />
            </Badge>
          </IconButton>
        )}
        {headerStates.showCredits && (
          <div className={classes.coins}>
            <div>
              <span>{info.score}</span>
              <Coin />
            </div>
            <div>
              <span>{info.credit}</span>
              <MoneyBag />
            </div>
          </div>
        )}
        {headerStates.showExit && (
          <button className={classes.exit} onClick={exitFn}>
            <span>{t('common.exit')}</span>
            <ExitToAppRoundedIcon />
          </button>
        )}
        {headerStates.showSettings && (
          <div className={classes.back}>
            <IconButton
              edge={'start'}
              onClick={() => history.push(routes.SETTINGS)}
            >
              <SettingsIcon />
            </IconButton>
          </div>
        )}
        {headerStates.showBack && (
          <div className={classes.back}>
            <IconButton edge={'start'} onClick={history.goBack}>
              <ArrowBackIosRoundedIcon />
            </IconButton>
          </div>
        )}
        <SwipeableDrawer
          anchor={isRtl ? 'right' : 'left'}
          open={open}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
        >
          <aside className={styles.wrapper}>
            <div className={styles.container}>
              {/*<div*/}
              {/*  className={styles.guidline}*/}
              {/*  onClick={() =>*/}
              {/*    (window.location.href = 'https://o2reco.ir/help')*/}
              {/*  }*/}
              {/*>*/}
              {/*  <QuestionMarkIcon />*/}
              {/*</div>*/}
              <img src={Logo} alt="logo" className={styles.logo} />
              <div className={styles.coins}>
                <div>
                  <div>
                    <Coin />
                    <span>{t('common.scoreLabel')}</span>
                  </div>
                  <span>{userInfo.score}</span>
                </div>
                <div>
                  <div>
                    <MoneyBag />
                    <span>{t('common.creditLabel')}</span>
                  </div>
                  <span>{userInfo.credit}</span>
                </div>
              </div>
              <NavLink
                className={styles.nav}
                to={routes.ANNOUNCEMENTS}
                onClick={(e) => handleNavClick(e)}
              >
                <CampaignRoundedIcon fontSize={'default'} />
                <span>{t('nav.announcements')}</span>
              </NavLink>
              <NavLink
                className={styles.nav}
                to={routes.OCCASIONS}
                onClick={(e) => handleNavClick(e)}
              >
                <CakeIcon />
                <span>{t('nav.occasions')}</span>
              </NavLink>
              {modules.survey && (
                <NavLink
                  className={styles.nav}
                  to={routes.SURVEYS}
                  onClick={(e) => handleNavClick(e)}
                >
                  <PollIcon />
                  <span>{t('nav.surveys')}</span>
                </NavLink>
              )}
              {hasFeedback && (
                <NavLink
                  className={styles.nav}
                  to={routes.FEEDBACKS}
                  onClick={(e) => handleNavClick(e)}
                >
                  <ThumbsUpDownIcon />
                  <span>{t('nav.conversations')}</span>
                </NavLink>
              )}
              <NavLink
                className={styles.nav}
                to={routes.SEARCH}
                onClick={(e) => handleNavClick(e)}
              >
                <SearchRoundedIcon fontSize={'default'} />
                <span>{t('nav.search')}</span>
              </NavLink>
              <NavLink
                className={styles.nav}
                to={'https://o2reco.ir/help'}
                onClick={(e) =>
                  window.open(
                    'https://o2reco.ir/help',
                    '_blank',
                    'noopener,noreferrer'
                  )
                    ? e.preventDefault()
                    : null
                }
              >
                <QuestionMarkIcon fontSize={'default'} />
                <span>{t('nav.help')}</span>
              </NavLink>
              {/*{(data?.is_org_admin ||*/}
              {/*  data?.is_sys_admin ||*/}
              {/*  data?.is_department_manager) && (*/}
              {/*  <>*/}
              {/*    <div className={styles.nav}>ادمین سازمان</div>*/}
              {/*    {(data?.is_org_admin || data?.is_sys_admin) &&*/}
              {/*      data?.organization.bi_dashboard_link && (*/}
              {/*        <a*/}
              {/*          className={styles.nav}*/}
              {/*          href={data?.organization.bi_dashboard_link}*/}
              {/*          onClick={(e) =>*/}
              {/*            currentPath === routes.SURVEY*/}
              {/*              ? e.preventDefault()*/}
              {/*              : null*/}
              {/*          }*/}
              {/*          target="_blank"*/}
              {/*          rel="noreferrer"*/}
              {/*        >*/}
              {/*          <ShowChartIcon />*/}
              {/*          <span>داشبورد bi</span>*/}
              {/*        </a>*/}
              {/*      )}*/}

              {/*    <a*/}
              {/*      href={*/}
              {/*        env === 'demo'*/}
              {/*          ? 'https://demo-admin.o2reco.ir'*/}
              {/*          : 'https://admin.o2reco.ir'*/}
              {/*      }*/}
              {/*      className={styles.nav}*/}
              {/*      target="_blank"*/}
              {/*      rel="noreferrer"*/}
              {/*    >*/}
              {/*      <DashboardIcon />*/}
              {/*      <span>ادمین پنل</span>*/}
              {/*    </a>*/}
              {/*  </>*/}
              {/*)}*/}
            </div>
          </aside>
        </SwipeableDrawer>
      </AppBar>
    </HeaderScrollEffect>
  );
};

Header.propTypes = {
  window: PropTypes.fun,
  location: PropTypes.object
};

export default Header;
